import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Copy, Check, User } from 'lucide-react';
import { toast } from 'sonner';
import { copyToClipboard } from '@/utils/clipboard';

export default function UDTUserIDCard({ user }) {
  const [copied, setCopied] = useState(false);

  const copyUDTID = async () => {
    if (user?.udt_user_id) {
      const success = await copyToClipboard(user.udt_user_id, 'UDT User ID copied!');
      if (success) {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    }
  };

  if (!user?.udt_user_id) {
    return null;
  }

  return (
    <Card className="border-2 min-w-0" style={{ borderColor: '#0F52BA', background: 'linear-gradient(135deg, #E8F2FF 0%, #F5F9FF 100%)' }}>
      <CardContent className="p-3 sm:p-4">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: '#0F52BA' }}>
              <User className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-semibold" style={{ color: '#666' }}>Your UDT User ID</p>
              <p className="text-base sm:text-xl font-mono font-bold break-all" style={{ color: '#0F52BA' }}>
                {user.udt_user_id}
              </p>
              <p className="text-xs mt-1" style={{ color: '#666' }}>Share this ID to receive documents</p>
            </div>
          </div>
          <Button
            onClick={copyUDTID}
            size="sm"
            style={{ background: copied ? '#10b981' : '#0F52BA' }}
          >
            {copied ? (
              <>
                <Check className="w-4 h-4 mr-1" />
                Copied
              </>
            ) : (
              <>
                <Copy className="w-4 h-4 mr-1" />
                Copy
              </>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
